function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";
import { get } from "lodash/object";
import tooltipConfig from "./SpsTooltipConfig";
import { Position, PositioningService } from "@spscommerce/positioning";

var SpsTooltip = function (_Component) {
  _inherits(SpsTooltip, _Component);

  function SpsTooltip(props) {
    _classCallCheck(this, SpsTooltip);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.showTip = function (e) {
      var _this$props = _this.props,
          position = _this$props.position,
          children = _this$props.children,
          offsets = _this$props.offsets;

      if (!children) {
        console.error("sps-tooltip is empty; aborting show");
        return;
      }
      if (_this._hideTimer) {
        _this._clearHideDelay();
      }
      if (!_this.state.show) {
        _this.setState({
          show: true,
          side: position
        }, function () {
          _this._positioningService.position(_this.wrapper, {
            relativeTo: _this.state.attachedTo,
            position: _this.state.side,
            offsets: offsets.split(/, ?/).map(function (offset) {
              return parseInt(offset, 10);
            })
          });
        });
      }
    };

    _this.hideTip = function (e) {
      var hideDelay = _this.props.hideDelay;

      if (_this._hideTimer) {
        _this._clearHideDelay();
      }
      if (_this.state.show) {
        _this._hideTimer = setTimeout(function () {
          _this.setState({ show: false }, function () {
            _this._positioningService.release(_this.wrapper);
          });
        }, hideDelay);
      }
    };

    _this._clearHideDelay = function () {
      if (_this._hideTimer) {
        clearTimeout(_this._hideTimer);
        delete _this._hideTimer;
      }
    };

    _this.toggleTip = function (e) {
      var show = _this.state.show;

      if (show) {
        _this.hideTip(e);
      } else {
        _this.showTip(e);
      }
    };

    _this.bindTargetListener = function (target) {
      var customTriggers = _this.props.customTriggers;

      if (target) {
        if (customTriggers && customTriggers.show && customTriggers.hide && customTriggers.show !== customTriggers.hide) {
          target.addEventListener(customTriggers.show, _this.showTip, false);
          target.addEventListener(customTriggers.hide, _this.hideTip, false);
        } else if (customTriggers && customTriggers.show && customTriggers.hide && customTriggers.show === customTriggers.hide) {
          target.addEventListener(customTriggers.show, _this.toggleTip, false);
        } else if (_this.props.showOn === tooltipConfig.TooltipShowTrigger.MOUSEOVER) {
          target.addEventListener("mouseenter", _this.showTip, false);
          target.addEventListener("mouseleave", _this.hideTip, false);
        }
      }
    };

    _this.unbindTargetListener = function (target) {
      var customTriggers = _this.props.customTriggers;

      if (target) {
        if (customTriggers && customTriggers.show && customTriggers.show !== customTriggers.hide) {
          target.removeEventListener(customTriggers.show, _this.showTip, false);
          target.removeEventListener(customTriggers.hide, _this.hideTip, false);
        } else if (customTriggers && customTriggers.show && customTriggers.show === customTriggers.hide) {
          target.removeEventListener(customTriggers.show, _this.toggleTip, false);
        } else {
          target.removeEventListener("mouseenter", _this.showTip, false);
          target.removeEventListener("mouseleave", _this.hideTip, false);
        }
      }
    };

    _this.getTipEl = function () {
      var _this$props2 = _this.props,
          kind = _this$props2.kind,
          title = _this$props2.title,
          children = _this$props2.children;

      var placement = _this.state.side;

      var tipClass = classnames("sps-tooltip", "sps-tooltip--" + kind, "sps-tooltip--pos-" + placement.replace(" ", "-"), {
        "sps-tooltip--shown": _this.state.show
      });

      return React.createElement(
        "div",
        { className: tipClass, ref: function ref(el) {
            return _this.wrapper = el;
          } },
        title ? React.createElement(
          "div",
          { className: "sps-tooltip__title" },
          title
        ) : null,
        React.createElement(
          "div",
          { className: "sps-tooltip__body" },
          children
        ),
        React.createElement("span", { className: "sps-tooltip__caret" })
      );
    };

    _this.state = {
      show: false,
      side: Position.TOP_MIDDLE
    };
    _this._positioningService = new PositioningService();
    return _this;
  }

  SpsTooltip.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        elementFor = _props.elementFor,
        showOn = _props.showOn;

    var target = document.getElementById(elementFor) || this.wrapper.parentElement.querySelector("[name=\"" + elementFor + "\"]") || document.querySelector("[name=\"" + elementFor + "\"]");
    if (target) {
      this.bindTargetListener(target);
      this.setState({ attachedTo: target });
      if (showOn === tooltipConfig.TooltipShowTrigger.CLICK) {
        target.addEventListener("click", this.toggleTip);
      }
    } else {
      console.error("Failed to get target: please pass either id or name of target element");
    }
  };

  SpsTooltip.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unbindTargetListener(this.state.attachedTo);
  };

  SpsTooltip.prototype.render = function render() {
    return React.createElement(
      React.Fragment,
      null,
      this.getTipEl()
    );
  };

  return SpsTooltip;
}(Component);

export { SpsTooltip as default };

SpsTooltip.defaultProps = {
  showOn: tooltipConfig.TooltipShowTrigger.MOUSEOVER,
  kind: tooltipConfig.TooltipType.DEFAULT,
  position: Position.TOP_MIDDLE,
  offsets: "13, 0",
  hideDelay: 1000
};